import * as React from "react";
import { ReportProps } from "../../../../types/types";
import "./../ReportCreationFormPages.css";
import {
  commonPost,
  commonGet,
  getUserList, getNameFromEmail,
  getReport,
} from "../../../../services/reportService";
import { useAuth } from "../../../../providers/AuthProvider";
import { EnvironmentRegistry } from "../../../../services/registry/environmentRegistry";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/lab/LoadingButton";
import { showNotification } from "@mantine/notifications";
import { X } from "tabler-icons-react";
import { ConfirmationPopUp } from "../../../popup/confirmationPopUp";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { ArrayUtils } from "../../../../utils/arrayUtils";
import { Text } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";

export function popNotification(
  title: string,
  message: string,
  color: string,
  icon?: any
): void {
  showNotification({
    title,
    message,
    color,
    icon,
    autoClose: 5000,
  });
}

// const options = [
//   { value: "QUERY", label: "Queryw" },
//   { value: "entity", label: "Entity" },
// ];

export function FinalPreviewPage(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  const ReportInfos = props.reportInfo;

  const [openDownloadConfirmationModal, setOpenDownloadConfirmationModal] =
    useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const [reviewers, setReviewers] = useState([
    { value: "Select_Owner_Name", label: "Select Owner Name" },
  ]);
  const [reviewer, setReviewer] = useState(
    ReportInfos.reviewer == null ? "Select_Owner_Name" : ReportInfos.reviewer
  );
  const [formValues, setFormValues] = useState([{ param: "", paramValue: "" }]);

  let handleChange = (i: number, e: React.ChangeEvent<HTMLInputElement>) => {
    let newFormValues = [...formValues];
    const eventName = e.target.name === "param" ? "param" : "paramValue";
    newFormValues[i][eventName] = e.target.value;
    setFormValues(newFormValues);
  };

  const reviewerError =
    ArrayUtils.isNotEmpty(props.validationErrors) &&
    props.validationErrors
      .filter((error) => error.property === "reviewer")
      .map((error) => error.message)[0];

  let addFormFields = useCallback((params: any) => {
    if (params) setFormValues(params);
    else setFormValues([...formValues, { param: "", paramValue: "" }]);
  },[formValues]);

  let removeFormFields = (i: any) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  const ReportInfo = props.reportInfo;
  const QueryInfo = props.queryInfo;

  let downLoadReport = () => {
    
    setDownloading(true);
    let filter = formValues.map((entry, index) => {
      return { key: entry.param, value: entry.paramValue };
    });
    let finalObj = {
      attributes: {
        filter: { filters: filter },
        name: props.reportInfo.name,
        format: props.reportInfo.fileFormat,
        reportInfo: { ...props.reportInfo },
        queryInfo: { ...props.queryInfo },
      },
    };
    delete finalObj.attributes.queryInfo.UIParams; //props
    delete finalObj.attributes.queryInfo.params; //props
    delete finalObj.attributes.queryInfo.queryInfoBody; //props
    delete finalObj.attributes.queryInfo.data; //props
    delete finalObj.attributes.reportInfo.viewEditStatus; //porps
    delete finalObj.attributes.reportInfo.fileNameFormat; //ea
    delete finalObj.attributes.reportInfo.fileFormat; //ea

    commonPost("/tasks/types/report/execute", finalObj, authContext)
      .then(function (data) {
        popNotification(
          "Alert",
          "Download request submitten waiting for report generation",
          "green"
        );
        donwloadReportWithStatus(data.id);
      })
      .catch(function (data) {
        popNotification("Alert", JSON.stringify(data), "red", <X />);
      });
  };

  useEffect(() => {
    getUserList(authContext).then((data) => {
      data.map((user: any) => {
        user["label"] = user.fullname;
        user["value"] = user.username;
        return user;
      });
      setReviewers(data);
    });
  }, []);

  useEffect(() => {
    const owner = getNameFromEmail(false);
    if(owner != null){
      setReviewer(owner);
      ReportInfo.reviewer = owner;
    }
    getUserList(authContext).then((data) => {
      data.map((user: any) => {
        user["label"] = user.fullname;
        user["value"] = user.username;
        return user;
      });
      setReviewers([{ value: " ", label: "Select Owner Name" }, ...data]);
    });
  }, []);

  function donwloadReportWithStatus(id: string) {
    commonGet("/tasks/" + id, authContext).then(function (res) {
      let data = res.features[0];
      if (data.status === "SUCCESS") {
        setDownloading(false);
        download(id);
      } else if (data.status === "INPROGRESS") {
        setTimeout(() => donwloadReportWithStatus(id), 2000);
      } else {
        setDownloading(false);
        popNotification(
          "Alert",
          JSON.stringify(res.features[0].response),
          "red",
          <X />
        );
      }
    });
  }

  function download(id: string) {
    getReport(id);
  }

  const onChangeQuery = useCallback (() => {
    addFormFields(props.queryInfo.UIParams);
  },[addFormFields, props.queryInfo.UIParams]);

  useEffect(() => {
    onChangeQuery();
  }, [onChangeQuery]);

  

  const addReportReviewerName = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setReviewer(event.target.value);
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        reviewer: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "reviewer"
      ),
    }));
  };

  return (
    <div
      className="form-group-report wizard-content-card"
      style={{ height: "100%" }}
    >
      {/* Report Name */}

      <div className="full-width">
        <h2>Final Preview</h2>
        <div className="form-inline">
          <TableContainer sx={{ maxHeight: 500 }}>
            <Table stickyHeader aria-label="sticky table">
              <tr>
                <td>
                  <span style={{ fontWeight: "bold" }}>Report Name </span>
                </td>
                <td>
                  <input
                    type="text"
                    name="param"
                    value={ReportInfo.name}
                    disabled
                  />
                </td>
              </tr>

              {ReportInfo.type === "QUERY" ? (
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>Report Type </span>
                  </td>
                  <td>
                    <input type="text" name="param" value="QUERY" disabled />
                  </td>
                </tr>
              ) : (
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>Report Type </span>
                  </td>
                  <td>
                    <input type="text" name="param" value={"ENTITY"} disabled />
                  </td>
                </tr>
              )}

              {ReportInfo.type === "QUERY" ? (
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>Query Name </span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="param"
                      value={QueryInfo.name}
                      disabled
                    />
                  </td>
                </tr>
              ) : (
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>Entity Name </span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="param"
                      value={ReportInfo.name}
                      disabled
                    />
                  </td>
                </tr>
              )}

              {ReportInfo.type === "QUERY" ? (
                <tr>
                  <td>
                    <span style={{ fontWeight: "bold" }}>Query</span>
                  </td>
                  <td>
                    <textarea
                      rows={5}
                      cols={40}
                      name="param"
                      value={QueryInfo.query}
                      disabled
                    />
                  </td>
                </tr>
              ) : (
                ""
              )}
            </Table>
          </TableContainer>
        </div>
        <div>
          {/* <h3></h3> */}
          <h3>Test Downloading Report </h3>
          {/* {(props.queryInfo.UIParams?.length ?? 0) > 0 && (
            <div>
              <h4>Filters :</h4>
              <button
                className="remove-button add"
                type="button"
                onClick={() => addFormFields("")}
              >
                Add Params
              </button>
            </div>
          )} */}


          {formValues.map((element, index) => (
            <div className="form-inline" key={index}>
              <input
                type="text"
                name="param"
                value={element.param || ""}
                onChange={(e) => handleChange(index, e)}
                placeholder="Parameter Key"
              />
              <input
                type="text"
                name="paramValue"
                value={element.paramValue || ""}
                onChange={(e) => handleChange(index, e)}
                placeholder="Parameter Value"
              />
              <button
              style={{marginRight : "10px"}}
                className="remove-button add"
                type="button"
                onClick={() => addFormFields("")}
              >
                Add
              </button>
              {
                <button
                  type="button"
                  className="remove-button remove"
                  onClick={() => removeFormFields(index)}
                >
                  Remove
                </button>
              }
            </div>
          ))}

          {props.reportInfo.reviewingStatus === "REVIEW" ? (
            <div className="input-div">
              <TextField
                id="reviewer"
                select
                label="Rewiever:"
                value={reviewer}
                onChange={addReportReviewerName}
                sx={{ m: 1, width: "75%" }}
                SelectProps={{
                  native: false,
                }}
                placeholder="Select Reviewer Name"
                helperText="Select your beanstalk Name"
              >
                {reviewers.map((option: any) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              {reviewerError && <Text color="red">{reviewerError}</Text>}
            </div>
          ) : null}
          <ConfirmationPopUp
            message="Do you want to download report?"
            openConfirmModal={openDownloadConfirmationModal}
            setOpenConfirmModal={setOpenDownloadConfirmationModal}
            successMethod={() => downLoadReport()}
          />
          <div className={"kpi-setup-buttons"}>
            {downloading ? (
              <LoadingButton
                loading
                color="success"
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="outlined"
              >
                Downloading
              </LoadingButton>
            ) : (
              <LoadingButton
                onClick={(e: any) => {
                  e.preventDefault();
                  setOpenDownloadConfirmationModal(true);
                }}
                color="success"
                loadingPosition="start"
                variant="outlined"
              >
                Download
              </LoadingButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
